/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as EinladungRouteImport } from './routes/einladung'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MeRouteRouteImport } from './routes/me/route'
import { Route as AdminMandantenRouteImport } from './routes/admin/mandanten'
import { Route as AdminSystemRouteImport } from './routes/admin/system'
import { Route as MeAbrechnenRouteImport } from './routes/me/abrechnen'
import { Route as MePipelineRouteImport } from './routes/me/pipeline'
import { Route as MeProfilRouteImport } from './routes/me/profil'
import { Route as MeProvisionenRouteImport } from './routes/me/provisionen'
import { Route as MeRechnungenRouteImport } from './routes/me/rechnungen'
import { Route as TTenantIdRouteRouteImport } from './routes/t/$tenantId/route'
import { Route as TTenantIdAbschluesseRouteImport } from './routes/t/$tenantId/abschluesse'
import { Route as TTenantIdDashboardRouteImport } from './routes/t/$tenantId/dashboard'
import { Route as TTenantIdEinstellungenRouteImport } from './routes/t/$tenantId/einstellungen'
import { Route as TTenantIdExporteRouteImport } from './routes/t/$tenantId/exporte'
import { Route as TTenantIdProvisionenRouteImport } from './routes/t/$tenantId/provisionen'
import { Route as TTenantIdPruefenRouteImport } from './routes/t/$tenantId/pruefen'
import { Route as TTenantIdRechnungenRouteImport } from './routes/t/$tenantId/rechnungen'
import { Route as TTenantIdRegelnRouteImport } from './routes/t/$tenantId/regeln'
import { Route as TTenantIdZahlungenRouteImport } from './routes/t/$tenantId/zahlungen'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const EinladungRoute = EinladungRouteImport.update({
  id: '/einladung',
  path: '/einladung',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRouteRoute = MeRouteRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMandantenRoute = AdminMandantenRouteImport.update({
  id: '/mandanten',
  path: '/mandanten',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSystemRoute = AdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AdminRouteRoute,
} as any)
const MeAbrechnenRoute = MeAbrechnenRouteImport.update({
  id: '/abrechnen',
  path: '/abrechnen',
  getParentRoute: () => MeRouteRoute,
} as any)
const MePipelineRoute = MePipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => MeRouteRoute,
} as any)
const MeProfilRoute = MeProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => MeRouteRoute,
} as any)
const MeProvisionenRoute = MeProvisionenRouteImport.update({
  id: '/provisionen',
  path: '/provisionen',
  getParentRoute: () => MeRouteRoute,
} as any)
const MeRechnungenRoute = MeRechnungenRouteImport.update({
  id: '/rechnungen',
  path: '/rechnungen',
  getParentRoute: () => MeRouteRoute,
} as any)
const TTenantIdRouteRoute = TTenantIdRouteRouteImport.update({
  id: '/t/$tenantId',
  path: '/t/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const TTenantIdAbschluesseRoute = TTenantIdAbschluesseRouteImport.update({
  id: '/abschluesse',
  path: '/abschluesse',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdDashboardRoute = TTenantIdDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdEinstellungenRoute = TTenantIdEinstellungenRouteImport.update({
  id: '/einstellungen',
  path: '/einstellungen',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdExporteRoute = TTenantIdExporteRouteImport.update({
  id: '/exporte',
  path: '/exporte',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdProvisionenRoute = TTenantIdProvisionenRouteImport.update({
  id: '/provisionen',
  path: '/provisionen',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdPruefenRoute = TTenantIdPruefenRouteImport.update({
  id: '/pruefen',
  path: '/pruefen',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdRechnungenRoute = TTenantIdRechnungenRouteImport.update({
  id: '/rechnungen',
  path: '/rechnungen',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdRegelnRoute = TTenantIdRegelnRouteImport.update({
  id: '/regeln',
  path: '/regeln',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)
const TTenantIdZahlungenRoute = TTenantIdZahlungenRouteImport.update({
  id: '/zahlungen',
  path: '/zahlungen',
  getParentRoute: () => TTenantIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/einladung': typeof EinladungRoute
  '/login': typeof LoginRoute
  '/t/$tenantId': typeof TTenantIdRouteRouteWithChildren
  '/admin/mandanten': typeof AdminMandantenRoute
  '/admin/system': typeof AdminSystemRoute
  '/me/abrechnen': typeof MeAbrechnenRoute
  '/me/pipeline': typeof MePipelineRoute
  '/me/profil': typeof MeProfilRoute
  '/me/provisionen': typeof MeProvisionenRoute
  '/me/rechnungen': typeof MeRechnungenRoute
  '/t/$tenantId/abschluesse': typeof TTenantIdAbschluesseRoute
  '/t/$tenantId/dashboard': typeof TTenantIdDashboardRoute
  '/t/$tenantId/einstellungen': typeof TTenantIdEinstellungenRoute
  '/t/$tenantId/exporte': typeof TTenantIdExporteRoute
  '/t/$tenantId/provisionen': typeof TTenantIdProvisionenRoute
  '/t/$tenantId/pruefen': typeof TTenantIdPruefenRoute
  '/t/$tenantId/rechnungen': typeof TTenantIdRechnungenRoute
  '/t/$tenantId/regeln': typeof TTenantIdRegelnRoute
  '/t/$tenantId/zahlungen': typeof TTenantIdZahlungenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/einladung': typeof EinladungRoute
  '/login': typeof LoginRoute
  '/t/$tenantId': typeof TTenantIdRouteRouteWithChildren
  '/admin/mandanten': typeof AdminMandantenRoute
  '/admin/system': typeof AdminSystemRoute
  '/me/abrechnen': typeof MeAbrechnenRoute
  '/me/pipeline': typeof MePipelineRoute
  '/me/profil': typeof MeProfilRoute
  '/me/provisionen': typeof MeProvisionenRoute
  '/me/rechnungen': typeof MeRechnungenRoute
  '/t/$tenantId/abschluesse': typeof TTenantIdAbschluesseRoute
  '/t/$tenantId/dashboard': typeof TTenantIdDashboardRoute
  '/t/$tenantId/einstellungen': typeof TTenantIdEinstellungenRoute
  '/t/$tenantId/exporte': typeof TTenantIdExporteRoute
  '/t/$tenantId/provisionen': typeof TTenantIdProvisionenRoute
  '/t/$tenantId/pruefen': typeof TTenantIdPruefenRoute
  '/t/$tenantId/rechnungen': typeof TTenantIdRechnungenRoute
  '/t/$tenantId/regeln': typeof TTenantIdRegelnRoute
  '/t/$tenantId/zahlungen': typeof TTenantIdZahlungenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/me': typeof MeRouteRouteWithChildren
  '/einladung': typeof EinladungRoute
  '/login': typeof LoginRoute
  '/t/$tenantId': typeof TTenantIdRouteRouteWithChildren
  '/admin/mandanten': typeof AdminMandantenRoute
  '/admin/system': typeof AdminSystemRoute
  '/me/abrechnen': typeof MeAbrechnenRoute
  '/me/pipeline': typeof MePipelineRoute
  '/me/profil': typeof MeProfilRoute
  '/me/provisionen': typeof MeProvisionenRoute
  '/me/rechnungen': typeof MeRechnungenRoute
  '/t/$tenantId/abschluesse': typeof TTenantIdAbschluesseRoute
  '/t/$tenantId/dashboard': typeof TTenantIdDashboardRoute
  '/t/$tenantId/einstellungen': typeof TTenantIdEinstellungenRoute
  '/t/$tenantId/exporte': typeof TTenantIdExporteRoute
  '/t/$tenantId/provisionen': typeof TTenantIdProvisionenRoute
  '/t/$tenantId/pruefen': typeof TTenantIdPruefenRoute
  '/t/$tenantId/rechnungen': typeof TTenantIdRechnungenRoute
  '/t/$tenantId/regeln': typeof TTenantIdRegelnRoute
  '/t/$tenantId/zahlungen': typeof TTenantIdZahlungenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/me'
    | '/einladung'
    | '/login'
    | '/t/$tenantId'
    | '/admin/mandanten'
    | '/admin/system'
    | '/me/abrechnen'
    | '/me/pipeline'
    | '/me/profil'
    | '/me/provisionen'
    | '/me/rechnungen'
    | '/t/$tenantId/abschluesse'
    | '/t/$tenantId/dashboard'
    | '/t/$tenantId/einstellungen'
    | '/t/$tenantId/exporte'
    | '/t/$tenantId/provisionen'
    | '/t/$tenantId/pruefen'
    | '/t/$tenantId/rechnungen'
    | '/t/$tenantId/regeln'
    | '/t/$tenantId/zahlungen'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/me'
    | '/einladung'
    | '/login'
    | '/t/$tenantId'
    | '/admin/mandanten'
    | '/admin/system'
    | '/me/abrechnen'
    | '/me/pipeline'
    | '/me/profil'
    | '/me/provisionen'
    | '/me/rechnungen'
    | '/t/$tenantId/abschluesse'
    | '/t/$tenantId/dashboard'
    | '/t/$tenantId/einstellungen'
    | '/t/$tenantId/exporte'
    | '/t/$tenantId/provisionen'
    | '/t/$tenantId/pruefen'
    | '/t/$tenantId/rechnungen'
    | '/t/$tenantId/regeln'
    | '/t/$tenantId/zahlungen'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/me'
    | '/einladung'
    | '/login'
    | '/t/$tenantId'
    | '/admin/mandanten'
    | '/admin/system'
    | '/me/abrechnen'
    | '/me/pipeline'
    | '/me/profil'
    | '/me/provisionen'
    | '/me/rechnungen'
    | '/t/$tenantId/abschluesse'
    | '/t/$tenantId/dashboard'
    | '/t/$tenantId/einstellungen'
    | '/t/$tenantId/exporte'
    | '/t/$tenantId/provisionen'
    | '/t/$tenantId/pruefen'
    | '/t/$tenantId/rechnungen'
    | '/t/$tenantId/regeln'
    | '/t/$tenantId/zahlungen'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  MeRouteRoute: typeof MeRouteRouteWithChildren
  EinladungRoute: typeof EinladungRoute
  LoginRoute: typeof LoginRoute
  TTenantIdRouteRoute: typeof TTenantIdRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/einladung': {
      id: '/einladung'
      path: '/einladung'
      fullPath: '/einladung'
      preLoaderRoute: typeof EinladungRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/mandanten': {
      id: '/admin/mandanten'
      path: '/mandanten'
      fullPath: '/admin/mandanten'
      preLoaderRoute: typeof AdminMandantenRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/system': {
      id: '/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AdminSystemRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/me/abrechnen': {
      id: '/me/abrechnen'
      path: '/abrechnen'
      fullPath: '/me/abrechnen'
      preLoaderRoute: typeof MeAbrechnenRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/pipeline': {
      id: '/me/pipeline'
      path: '/pipeline'
      fullPath: '/me/pipeline'
      preLoaderRoute: typeof MePipelineRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/profil': {
      id: '/me/profil'
      path: '/profil'
      fullPath: '/me/profil'
      preLoaderRoute: typeof MeProfilRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/provisionen': {
      id: '/me/provisionen'
      path: '/provisionen'
      fullPath: '/me/provisionen'
      preLoaderRoute: typeof MeProvisionenRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/me/rechnungen': {
      id: '/me/rechnungen'
      path: '/rechnungen'
      fullPath: '/me/rechnungen'
      preLoaderRoute: typeof MeRechnungenRouteImport
      parentRoute: typeof MeRouteRoute
    }
    '/t/$tenantId': {
      id: '/t/$tenantId'
      path: '/t/$tenantId'
      fullPath: '/t/$tenantId'
      preLoaderRoute: typeof TTenantIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$tenantId/abschluesse': {
      id: '/t/$tenantId/abschluesse'
      path: '/abschluesse'
      fullPath: '/t/$tenantId/abschluesse'
      preLoaderRoute: typeof TTenantIdAbschluesseRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/dashboard': {
      id: '/t/$tenantId/dashboard'
      path: '/dashboard'
      fullPath: '/t/$tenantId/dashboard'
      preLoaderRoute: typeof TTenantIdDashboardRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/einstellungen': {
      id: '/t/$tenantId/einstellungen'
      path: '/einstellungen'
      fullPath: '/t/$tenantId/einstellungen'
      preLoaderRoute: typeof TTenantIdEinstellungenRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/exporte': {
      id: '/t/$tenantId/exporte'
      path: '/exporte'
      fullPath: '/t/$tenantId/exporte'
      preLoaderRoute: typeof TTenantIdExporteRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/provisionen': {
      id: '/t/$tenantId/provisionen'
      path: '/provisionen'
      fullPath: '/t/$tenantId/provisionen'
      preLoaderRoute: typeof TTenantIdProvisionenRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/pruefen': {
      id: '/t/$tenantId/pruefen'
      path: '/pruefen'
      fullPath: '/t/$tenantId/pruefen'
      preLoaderRoute: typeof TTenantIdPruefenRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/rechnungen': {
      id: '/t/$tenantId/rechnungen'
      path: '/rechnungen'
      fullPath: '/t/$tenantId/rechnungen'
      preLoaderRoute: typeof TTenantIdRechnungenRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/regeln': {
      id: '/t/$tenantId/regeln'
      path: '/regeln'
      fullPath: '/t/$tenantId/regeln'
      preLoaderRoute: typeof TTenantIdRegelnRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
    '/t/$tenantId/zahlungen': {
      id: '/t/$tenantId/zahlungen'
      path: '/zahlungen'
      fullPath: '/t/$tenantId/zahlungen'
      preLoaderRoute: typeof TTenantIdZahlungenRouteImport
      parentRoute: typeof TTenantIdRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminMandantenRoute: typeof AdminMandantenRoute
  AdminSystemRoute: typeof AdminSystemRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminMandantenRoute: AdminMandantenRoute,
  AdminSystemRoute: AdminSystemRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface MeRouteRouteChildren {
  MeAbrechnenRoute: typeof MeAbrechnenRoute
  MePipelineRoute: typeof MePipelineRoute
  MeProfilRoute: typeof MeProfilRoute
  MeProvisionenRoute: typeof MeProvisionenRoute
  MeRechnungenRoute: typeof MeRechnungenRoute
}

const MeRouteRouteChildren: MeRouteRouteChildren = {
  MeAbrechnenRoute: MeAbrechnenRoute,
  MePipelineRoute: MePipelineRoute,
  MeProfilRoute: MeProfilRoute,
  MeProvisionenRoute: MeProvisionenRoute,
  MeRechnungenRoute: MeRechnungenRoute,
}

const MeRouteRouteWithChildren =
  MeRouteRoute._addFileChildren(MeRouteRouteChildren)

interface TTenantIdRouteRouteChildren {
  TTenantIdAbschluesseRoute: typeof TTenantIdAbschluesseRoute
  TTenantIdDashboardRoute: typeof TTenantIdDashboardRoute
  TTenantIdEinstellungenRoute: typeof TTenantIdEinstellungenRoute
  TTenantIdExporteRoute: typeof TTenantIdExporteRoute
  TTenantIdProvisionenRoute: typeof TTenantIdProvisionenRoute
  TTenantIdPruefenRoute: typeof TTenantIdPruefenRoute
  TTenantIdRechnungenRoute: typeof TTenantIdRechnungenRoute
  TTenantIdRegelnRoute: typeof TTenantIdRegelnRoute
  TTenantIdZahlungenRoute: typeof TTenantIdZahlungenRoute
}

const TTenantIdRouteRouteChildren: TTenantIdRouteRouteChildren = {
  TTenantIdAbschluesseRoute: TTenantIdAbschluesseRoute,
  TTenantIdDashboardRoute: TTenantIdDashboardRoute,
  TTenantIdEinstellungenRoute: TTenantIdEinstellungenRoute,
  TTenantIdExporteRoute: TTenantIdExporteRoute,
  TTenantIdProvisionenRoute: TTenantIdProvisionenRoute,
  TTenantIdPruefenRoute: TTenantIdPruefenRoute,
  TTenantIdRechnungenRoute: TTenantIdRechnungenRoute,
  TTenantIdRegelnRoute: TTenantIdRegelnRoute,
  TTenantIdZahlungenRoute: TTenantIdZahlungenRoute,
}

const TTenantIdRouteRouteWithChildren = TTenantIdRouteRoute._addFileChildren(
  TTenantIdRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  MeRouteRoute: MeRouteRouteWithChildren,
  EinladungRoute: EinladungRoute,
  LoginRoute: LoginRoute,
  TTenantIdRouteRoute: TTenantIdRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
